export default __webpack_public_path__ + "static/summer_containers48-71e1bb2b33b961f8d643873772a8fc2f.webp";